// extracted by mini-css-extract-plugin
export default {"selectBrand":"add-update-device-modal_selectBrand__h6Bnt","optionList":"add-update-device-modal_optionList__LyqV9"};